// extracted by mini-css-extract-plugin
module.exports = {"loading_background":"loading_loading_background__2HIyO","svg":"loading_svg__317Ha"};